import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Menu,
  ListItemText,
  ListItemIcon,
  Drawer,
  IconButton,
  CircularProgress,
} from '@mui/material';
import {
  DropDownType,
  ListType,
  MVPFiltersProps,
} from '../../advanta-mvp-charts/constants';
import { MVPDataTableInternal } from '../components/table';
import {
  TextField,
  MenuItem,
  Button,
  // InputAdornment,
} from '@mui/material';
// import SearchIcon from '@mui/icons-material/Search';
import HistoryIcon from '@mui/icons-material/History';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/Download';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ImportUsersDrawer from '../components/importUserDrawer';
import CommonAppBarAdmin from '../../../components/commonAppBarAdmin';
import * as yup from 'yup';
import { useFormWithSchema } from '../../../utils/functions/yupFormTypescript';
import {
  AutoCompleteController,
  InputController,
} from '../../../components';
import MultiSelect from '../../../components/formControllers/multiSelect';
import * as regex from '../../../utils/constants/regex';

import {
  TFieldDetails2,
  TFieldReport,
  TRequestTableDataByTableType,
} from '../../../../src/types/mvpCharts';
import { useRowSelect } from '../../../components/Table/actionNodes';
import EditIcon from '@mui/icons-material/Edit';
import EditDrawer from '../components/editDrawer';
import {
  useAddOrUpdateDataByTableTypeMutation,
  useGetTableDataByTableTypeQuery,
  useUpdateDropdownHierarchyQuery,
} from '../../../services/mVPGraphQlService';
import { useDispatch, useSelector } from 'react-redux';
import { showAlert } from '../../../services/alert';
import '../index.scss';
import { RootState } from '../../../store';
import dayjs from 'dayjs';
import arrow from '../../../assets/icons/line_arrow-close-left.svg';

export const userSchema = yup.object({
  name: yup.string().required('Name is required'),
  ugdn: yup.string().required('Ugdn is required'),
  mobileDetails: yup
    .string()
    .required('Mobile Number is required')

    .matches(
      regex.MOBILE_NUMBER,
      'Please enter valid number'
    ),
  //country: yup.string().required('Country is required'),
  userType: yup.string().required('Role is required'),
  userFunction: yup
    .string()
    .required('Function is required'),
  userSubFunction: yup
    .string()
    .required('Sub function is required'),
  //  fields: yup.string().required('Fields is required'),
  fields: yup.string(),
  tpm: yup.string(),
  regionManager: yup.string(),
  productionLead: yup.string(),
  scmLead: yup.string(),
});

export const UserManagement: React.FC<MVPFiltersProps> = ({
  onNavigate,
  onBack,
  filterValues: commonFilters,
}) => {
  const isThailand =
    useSelector(
      (state: RootState) => state.country.countryName
    ) === 'Thailand';

  const defaultValues = {
    name: '',
    ugdn: '',
    mobileDetails: '',
    emailId: '',
    //country: '',
    userType: '',
    userFunction: '',
    userSubFunction: '',
    fields: '',
    tpm: '',
    regionManager: '',
    productionLead: '',
    scmLead: '',
  };
  const formSchema = yup.object({
    name: yup.string().required('Name is required'),
    ugdn: yup.string().required('Ugdn is required'),
    mobileDetails: yup
      .string()
      .required('Mobile Number is required')

      .matches(
        regex.MOBILE_NUMBER,
        'Please enter valid number'
      ),
    emailId: isThailand
      ? yup
          .string()
          .email('Please enter a valid email')
          .required('Email is required')
      : yup.string().email('Please enter a valid email'),
    // country: yup.string().required('Country is required'),
    userType: yup.string().required('Role is required'),
    userFunction: yup
      .string()
      .required('Function is required'),
    userSubFunction: yup
      .string()
      .required('Sub function is required'),
    fields: yup.string(),
    tpm: yup.string().when('userType', {
      is: 'FA',
      then: (schema) =>
        schema.required('Parent is required'),
    }),
    regionManager: yup.string().when('userType', {
      is: 'TPM',
      then: (schema) =>
        schema.required('Parent is required'),
    }),
    productionLead: yup.string().when('userType', {
      is: 'REGION_MANAGER',
      then: (schema) =>
        schema.required('Parent is required'),
    }),
    scmLead: yup.string().when('userType', {
      is: 'PRODUCTION_LEAD',
      then: (schema) =>
        schema.required('Parent is required'),
    }),
  });

  const {
    formState: { errors },
    handleSubmit,
    register,
    control,
    reset,
    watch,
  } = useFormWithSchema(formSchema, {
    mode: 'onTouched',
    defaultValues,
  });
  const [drawerTab, setDrawerTab] = useState<
    'details' | 'audit'
  >('details');

  const [anchorEl, setAnchorEl] =
    useState<null | HTMLElement>(null);
  const [subMenuAnchorEl, setSubMenuAnchorEl] =
    useState<null | HTMLElement>(null);

  const [pageNo, setPageNo] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [tableData, setTableData] = useState<
    TFieldReport[]
  >([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [allTableData, setAllTableData] = useState<
    TFieldReport[]
  >([]);

  const MENU_CONFIG = {
    EMP_FIELD_CROP: {
      label: 'Field Crop',
      children: [
        {
          label: 'Production Team',
          value: 'SF_COMMERCIAL_SEED_PRODUCTION',
        },
        {
          label: 'Quality Team',
          value: 'SF_QUALITY_MANAGEMENT',
        },
      ],
    },
    EMP_VEGETABLE_CROP: {
      label: 'Vegetable Crop',
      children: [
        {
          label: 'Production Team',
          value: 'SF_COMMERCIAL_SEED_PRODUCTION',
        },
        {
          label: 'Quality Team',
          value: 'SF_QUALITY_MANAGEMENT',
        },
      ],
    },
  };

  const [openDrawer, setOpenDrawer] = useState(false);

  const handleOpenDrawer = () => setOpenDrawer(true);
  const handleCloseDrawer = () => {
    reset(defaultValues);
    setOpenDrawer(false);
  };
  const [openImportDrawer, setOpenImportDrawer] =
    useState(false);
  const [openEditDrawer, setOpenEditDrawer] =
    useState(false);

  const [addorUpdateRequest] =
    useAddOrUpdateDataByTableTypeMutation();
  const dispatch = useDispatch();

  const onSubmit = (data) => {
    const obj = {
      dataType: 'DT_ROW',
      tableType: 'TT_USER',
      wsId: wsId,
      dataPayload: {
        userRecord: {
          userDetails: {
            name: data.name,
            ugdn: data.ugdn,
            mobileDetails: {
              mobileNumber: data.mobileDetails,
              countryCode: countryCode,
            },
            ...(isThailand && { emailId: data.emailId }),
            country: countryName,
            userType: data.userType,
            userFunction: data.userFunction,
            userSubFunction: data.userSubFunction,
            status: true,
          },
          peopleId: {
            regionManagerId: data.regionManager,
            tpmId: data.tpm,
            faId: data.fa,
            scmId: data.scmLead,
            plId: data.productionLead,
          },
        },
      },
    };

    addorUpdateRequest(obj)
      .unwrap()
      .then((response) => {
        const inspectionData =
          response?.data?.AddOrUpdateDataByTableType;
        if (
          inspectionData?.responseStatus?.status ===
          'SUCCESS'
        ) {
          reset();
          setOpenDrawer(false);
          dispatch(
            showAlert({
              content: 'User added successfully',
            })
          );
          refetch();
        } else {
          dispatch(
            showAlert({
              content: `${inspectionData?.responseStatus?.errorMessages?.[0]}`,
              severity: 'error',
            })
          );
        }
      })
      .catch((err) => {
        console.error('Error:', err);
        dispatch(
          showAlert({
            content: 'something went wrong',
            severity: 'error',
          })
        );
      });
  };

  const ROLE_HIERARCHY = [
    'SCM_LEAD',
    'PRODUCTION_LEAD',
    'REGION_MANAGER',
    'TPM',
    'FA',
  ];
  const TOP_LEVEL_ROLES = [
    'SUPER_ADMIN',
    'DATA_ANALYST',
    'ADMIN',
  ];
  const ROLE_LABELS: Record<string, string> = {
    SUPER_ADMIN: 'SUPER ADMIN',
    ADMIN: 'ADMIN',
    DATA_ANALYST: 'DATA ANALYST',
    SCM_LEAD: 'SCM LEAD',
    PRODUCTION_LEAD: 'PRODUCTION LEAD',
    REGION_MANAGER: 'REGION MANAGER',
    TPM: isThailand ? 'APM' : 'TPM',
    FA: isThailand ? 'PE' : 'FIELD AGENTS',
  };

  const getVisibleRoles = (currentRole: string) => {
    if (TOP_LEVEL_ROLES.includes(currentRole)) {
      return ROLE_HIERARCHY;
    }

    const index = ROLE_HIERARCHY.indexOf(currentRole);

    if (index === -1) {
      return [];
    }

    return ROLE_HIERARCHY.slice(index + 1);
  };
  const user = useSelector(
    (state: RootState) => state.authUser
  );

  const currentRole = user?.role;

  const visibleRoles = getVisibleRoles(currentRole);

  const {
    checkbox,
    selectAllCheckBox,
    seletedIds,
    setSeletedIds,
  } = useRowSelect();

  const [hoveredRow, setHoveredRow] = useState<
    number | null
  >(null);
  const [selectedRowIndex, setSelectedRowIndex] = useState<
    number | null
  >(null);
  const [auditData, setAuditdata] = useState<[]>([]);

  const [selectedFieldNo, setSelectedFieldNo] = useState<
    number | null
  >(null);

  // const [searchTerm, setSearchTerm] = useState('');

  const [role, setRole] = useState(visibleRoles[0]);
  const [status, setStatus] = useState<
    'Active' | 'Inactive'
  >('Active');
  const DEFAULT_FUNCTION = 'EMP_FIELD_CROP';
  const DEFAULT_SUB_FUNCTION =
    'SF_COMMERCIAL_SEED_PRODUCTION';

  const [selectedFunction, setSelectedFunction] = useState(
    DEFAULT_FUNCTION
  );
  const [selectedSubFunction, setSelectedSubFunction] =
    useState(DEFAULT_SUB_FUNCTION);

  const [buttonLabel, setButtonLabel] = useState(
    'Field Crop / Production Team'
  );
  const handleMainMenuOpen = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMainMenuClose = () => {
    setAnchorEl(null);
    setSubMenuAnchorEl(null);
  };

  const handleSubMenuOpen = (
    event: React.MouseEvent<HTMLElement>,
    parentValue: string
  ) => {
    setSelectedFunction(parentValue);
    setSubMenuAnchorEl(event.currentTarget);
  };

  const handleSelectChild = (
    parentValue: string,
    childValue: string
  ) => {
    setSelectedFunction(parentValue);
    setSelectedSubFunction(childValue);

    const parentLabel = MENU_CONFIG[parentValue].label;
    const childLabel = MENU_CONFIG[
      parentValue
    ].children.find((c) => c.value === childValue)?.label;

    setButtonLabel(`${parentLabel} / ${childLabel}`);

    setAnchorEl(null);
    setSubMenuAnchorEl(null);
  };

  const wsId = useSelector(
    (state: RootState) => state.country.wsId
  );
  const countryName = useSelector(
    (state: RootState) => state.country.countryName
  );
  const countryCode = useSelector(
    (state: RootState) => state.country.countryCode
  );

  const queryParams: TRequestTableDataByTableType = {
    tableType: 'TT_USER',
    filter: {
      //searchTerm: searchTerm,
      searchTerm: '',
      role: role,
      functionn: selectedFunction,
      subFunction: selectedSubFunction,
      active: status == 'Active' ? true : false,
    },
    wsId: wsId,
    pageNumber: pageNo,
    pageSize: pageSize,
  };

  const {
    data: getTableData,
    isLoading,
    isFetching,
    refetch,
  } = useGetTableDataByTableTypeQuery(queryParams, {
    refetchOnMountOrArgChange: true, //change
  });

  useEffect(() => {
    setPageNo(0);
  }, [role, selectedFunction, selectedSubFunction, status]);

  useEffect(() => {
    if (
      getTableData?.data?.GetTableDataByTableType?.users
    ) {
      setTotalCount(
        getTableData?.data?.GetTableDataByTableType
          ?.totalCount || 0
      );
      setTableData(
        getTableData?.data?.GetTableDataByTableType?.users
      );

      setAllTableData(
        getTableData?.data?.GetTableDataByTableType?.users
      );
    }
  }, [getTableData]);

  const handlePageChange = (
    event: React.MouseEvent | null,
    newPageNumber: number
  ) => {
    setPageNo(newPageNumber);
    setTableData(
      getPaginatedData(
        newPageNumber,
        pageSize,
        allTableData
      )
    );
  };

  const getPaginatedData = (
    newPageNumber: number,
    itemsPerPage: number,
    allItemsList: TFieldReport[]
  ) => {
    const indexOfLastItem =
      (newPageNumber + 1) * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentPageItems = allItemsList?.slice(
      indexOfFirstItem,
      indexOfLastItem
    );
    return [...currentPageItems];
  };
  const headers =
    getTableData?.data?.GetTableDataByTableType?.tableMeta
      ?.headers;
  const PRIMARY_FIELD =
    getTableData?.data?.GetTableDataByTableType?.tableMeta
      ?.activeColumn; //active col
  const remainingHeaders = headers?.filter(
    (item) =>
      item !== PRIMARY_FIELD &&
      item !== 'userDetails' &&
      item !== 'auditRecords' &&
      item !== 'fieldCount' &&
      item !== 'totalUChildrenCount' &&
      item !== 'fieldNos' &&
      item !== 'accessExpiryTime' &&
      item !== 'peopleId' &&
      item !== 'userChildren' &&
      item !== 'status'
  );

  const actionFunction = (
    action: 'activate' | 'deactivate'
  ) => {
    const userRecord = seletedIds.map((userId) => ({
      userDetails: {
        userId,
        status: action == 'activate' ? true : false,
      },
    }));

    const obj = {
      dataType: 'DT_ROW',
      tableType: 'TT_USER',
      tableUpdateType: 'T_USER_STATUS',
      dataPayload: {
        userRecord,
      },
      wsId: wsId,
    };

    addorUpdateRequest(obj)
      .unwrap()
      .then((response) => {
        const inspectionData =
          response?.data?.AddOrUpdateDataByTableType;

        if (
          inspectionData?.responseStatus?.status ===
          'SUCCESS'
        ) {
          dispatch(
            showAlert({
              content: 'User updated successfully',
            })
          );
          setSeletedIds([]);
          refetch();
        } else {
          dispatch(
            showAlert({
              content: `${inspectionData?.responseStatus?.reasons?.[0]} - ${inspectionData?.responseStatus?.errorMessages?.[0]}`,
              severity: 'error',
            })
          );
          setSeletedIds([]);
          refetch();
        }
      })

      .catch((err) => {
        console.error('Error:', err);
        dispatch(
          showAlert({
            content: 'something went wrong2',
            severity: 'error',
          })
        );
      });
  };

  const transformUsers = (users = []) =>
    users?.map((user) => ({
      ...user.userDetails,
      accessExpiryTime:
        user.userDetails?.accessExpiryTime?.seconds ?? null,
      mobileDetails:
        user.userDetails?.mobileDetails?.mobileNumber ?? '',
      ...(user.empHierarchy || {}),
      ...(user.peopleId || {}),
      fieldNos: user.fieldNos ?? [],
      fieldCount: user.fieldCount ?? 0,
      userChildren: user.userChildren ?? [],
      totalUChildrenCount: user.totalUChildrenCount ?? 0,
      auditRecords: user?.auditRecords || [],
    }));

  const transformedResponse = {
    users: transformUsers(tableData),
  };

  const columnsss = [
    {
      key: 'selectRow',
      label: selectAllCheckBox(
        transformedResponse?.users?.map(
          (ele: any) => ele.userId
        ) || []
      ),
      cellModifier: (row: TFieldDetails2) =>
        checkbox(row.userId),
    },

    {
      key: 'name',
      label: 'Name',
      cellModifier: (row: TFieldDetails2) => {
        return assigneeNode(row);
      },
    },

    {
      key: 'audit',
      label: 'Audit',
      cellModifier: (row: TFieldDetails2) => {
        return viewHistoryNode(row);
      },
    },

    {
      key: 'status',
      label: 'Status',
      cellModifier: (data: TFieldDetails2) => {
        return (
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              px: '10px',
              py: '4px',
              borderRadius: '999px',
              border: `1px solid ${
                data?.status == true
                  ? '#12B76A'
                  : 'rgba(206, 206, 206, 1)'
              }`,
              backgroundColor:
                data?.status == true
                  ? '#ECFDF3'
                  : 'rgba(206, 206, 206, 0.3)',
              width: 'fit-content',
            }}>
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                backgroundColor:
                  data?.status == true
                    ? '#12B76A'
                    : 'rgba(206, 206, 206, 1)',
              }}
            />
            <Typography
              fontSize={13}
              fontWeight={500}
              color={
                data?.status == true
                  ? '#027A48'
                  : ' rgba(149, 149, 149, 1)'
              }>
              {data?.status == true ? 'Active' : 'Inactive'}
            </Typography>
          </Box>
        );
      },
    },
    ...(Array.isArray(remainingHeaders)
      ? remainingHeaders.map((item) => ({
          key: item,
          label: item,
        }))
      : []),
    {
      key: 'fieldNos',
      label: 'Field nos',

      cellModifier: (data: TFieldDetails2) => {
        return data?.fieldNos.length > 0 ? (
          <>
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                px: '10px',
                py: '4px',
                borderRadius: '999px',
                border: `1px solid ${'rgba(206, 206, 206, 1)'}`,
                backgroundColor: '#fff',
                width: 'fit-content',
              }}>
              <Typography fontSize={13} fontWeight={500}>
                {data?.fieldNos?.[0]}
              </Typography>
            </Box>{' '}
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                px: '10px',
                py: '4px',
                borderRadius: '999px',
                border: `1px solid ${'rgba(206, 206, 206, 1)'}`,
                backgroundColor: '#fff',
                width: 'fit-content',
              }}>
              <Typography fontSize={13} fontWeight={500}>
                {'+'}
                {data?.fieldCount - 1}
              </Typography>
            </Box>
          </>
        ) : (
          '-'
        );
      },
    },

    {
      key: 'accessExpiryTime',
      label: 'Access expiry time',
      cellModifier: (data) => {
        return data?.accessExpiryTime > 0
          ? dayjs(
              data?.accessExpiryTime
                ? data?.accessExpiryTime * 1000
                : 0
            ).format('DD/MM/YYYY')
          : '-';
      },
    },

    {
      key: 'peopleId',
      label:
        role == 'PRODUCTION_LEAD'
          ? 'Scm lead'
          : role == 'REGION_MANAGER'
          ? 'Production lead'
          : role == 'TPM'
          ? 'Region manager'
          : role == 'FA'
          ? isThailand
            ? 'Apm'
            : 'Tpm'
          : '',
      cellModifier: (data) => {
        return role == 'PRODUCTION_LEAD'
          ? data?.scmLead
          : role == 'REGION_MANAGER'
          ? data?.productionLead
          : role == 'TPM'
          ? data?.regionManager
          : role == 'FA'
          ? data?.tpm
          : role == 'SCM_LEAD'
          ? ''
          : '-';
      },
    },
    {
      key: 'userChildren',
      label:
        role == 'PRODUCTION_LEAD'
          ? 'Region manager'
          : role == 'REGION_MANAGER'
          ? isThailand
            ? 'APM'
            : 'TPM'
          : role == 'TPM'
          ? isThailand
            ? 'PE'
            : 'FA'
          : role == 'SCM_LEAD'
          ? 'Production lead'
          : '',
      cellModifier: (data) => {
        return data?.userChildren.length > 1
          ? `${data?.userChildren?.[0]} + ${
              data?.totalUChildrenCount - 1
            } more`
          : data?.userChildren.length == 1
          ? data?.userChildren?.[0]
          : role == 'FA'
          ? ''
          : '-';
      },
    },

    // ...(Array?.isArray(remainingHeaders)
    //   ? remainingHeaders?.map((item) => ({
    //       key: item,
    //       label: item,
    //     }))
    //   : []),
  ];

  const viewHistoryNode = (tableRowData: any) => {
    const rowIndex = transformedResponse?.users.findIndex(
      (item) => item.userId === tableRowData.userId
    );
    return (
      <>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          onMouseEnter={() =>
            setHoveredRow(tableRowData?.userId)
          }
          onMouseLeave={() => setHoveredRow(null)}>
          <Button
            startIcon={<VisibilityIcon />}
            onClick={() => {
              setDrawerTab('audit');
              setOpenEditDrawer(true);
              setSelectedFieldNo(tableRowData.userId);
              setSelectedRowIndex(rowIndex); // ✅ store index
              setAuditdata(tableRowData.auditRecords);
            }}
            sx={{
              textTransform: 'none',
              color: '#006970',
              fontWeight: 500,
            }}>
            View History
          </Button>
        </Box>
        {/* )} */}
      </>
    );
  };
  const assigneeNode = (tableRowData: any) => {
    const rowIndex = transformedResponse?.users.findIndex(
      (item) => item.userId === tableRowData.userId
    );

    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        onMouseEnter={() =>
          setHoveredRow(tableRowData?.userId)
        }
        onMouseLeave={() => setHoveredRow(null)}>
        <Typography fontSize={13} fontWeight={600}>
          {tableRowData?.name}
        </Typography>

        {hoveredRow === tableRowData?.userId &&
          tableRowData?.status === true && (
            <IconButton
              type="button"
              onClick={() => {
                setDrawerTab(
                  tableRowData?.status === true
                    ? 'details'
                    : 'audit'
                );
                setOpenEditDrawer(true);
                setSelectedFieldNo(tableRowData.userId);
                setSelectedRowIndex(rowIndex); // ✅ store index
                setAuditdata(tableRowData.auditRecords);
              }}>
              <EditIcon />
            </IconButton>
          )}
      </Box>
    );
  };

  const [rmListffc, setRegionManagerListFfc] = useState<
    DropDownType[]
  >([]);
  const [tpmListffc, setTpmListFfc] = useState<
    DropDownType[]
  >([]);
  const [plListffc, setPlListFfc] = useState<
    DropDownType[]
  >([]);
  const [scmListffc, setScmListFfc] = useState<
    DropDownType[]
  >([]);

  const { data } = useUpdateDropdownHierarchyQuery({
    commonFilters,
    fullHierarchy: true,
    wsId: wsId,
  });

  function getRegionalManagers(
    hierarchy: any[],
    type: string,
    parentId: number | null = null
  ): any[] {
    const regionalManagers: {
      type: string;
      name: string;
      id: number;
      parentId: number;
    }[] = [];

    hierarchy.forEach((item) => {
      if (item.data?.type === type) {
        regionalManagers.push({
          ...item.data,
          parentId,
        });
      }

      if (item.hierarchy && Array.isArray(item.hierarchy)) {
        regionalManagers.push(
          ...getRegionalManagers(
            item.hierarchy,
            type,
            item.data?.id || null
          )
        );
      }
    });

    return regionalManagers;
  }

  const getFormattedList = (
    list: Array<ListType>,
    parentId?: string | null
  ): DropDownType[] => {
    if (parentId) {
      const formattedList = list
        .filter((item) => item?.parentId === parentId)
        .map((item) => ({
          label: item?.name,
          value: item?.id,
        }));
      return formattedList;
    } else {
      const formattedList = list?.map((item) => ({
        label: item?.name,
        value: item?.id,
      }));
      return formattedList;
    }
  };

  useEffect(() => {
    if (!data?.data?.UpdateDropdownHierarchy) return;

    const regionalManagersFFC = getRegionalManagers(
      data.data.UpdateDropdownHierarchy.empHierarchyFfc
        ?.hierarchy || [],
      'REGION_MANAGER'
    );

    const tpmFFC = getRegionalManagers(
      data.data.UpdateDropdownHierarchy.empHierarchyFfc
        ?.hierarchy || [],
      'TPM'
    );

    const scmFFC = getRegionalManagers(
      data.data.UpdateDropdownHierarchy.empHierarchyFfc
        ?.hierarchy || [],
      'SCM_LEAD'
    );

    const plFFC = getRegionalManagers(
      data.data.UpdateDropdownHierarchy.empHierarchyFfc
        ?.hierarchy || [],
      'PRODUCTION_LEAD'
    );

    const formattedListoRmffc = regionalManagersFFC
      .map((item) => ({
        id: item.id,
        name: item.name,
        parentId: item.parentId,
      }))
      .filter((item) => item.name)
      .sort((a, b) => a.name.localeCompare(b.name));

    const formattedListoTpmffc = tpmFFC
      .map((item) => ({
        id: item.id,
        name: item.name,
        parentId: item.parentId,
      }))
      .filter((item) => item.name)
      .sort((a, b) => a.name.localeCompare(b.name));

    const formattedListoScmffc = scmFFC
      .map((item) => ({
        id: item.id,
        name: item.name,
        parentId: item.parentId,
      }))
      .filter((item) => item.name)
      .sort((a, b) => a.name.localeCompare(b.name));

    const formattedListoPlffc = plFFC
      .map((item) => ({
        id: item.id,
        name: item.name,
        parentId: item.parentId,
      }))
      .filter((item) => item.name)
      .sort((a, b) => a.name.localeCompare(b.name));

    setRegionManagerListFfc(
      getFormattedList(formattedListoRmffc)
    );
    setTpmListFfc(getFormattedList(formattedListoTpmffc));
    setScmListFfc(getFormattedList(formattedListoScmffc));
    setPlListFfc(getFormattedList(formattedListoPlffc));
  }, [data]);

  return (
    <div>
      <CommonAppBarAdmin
        height={'auto'}
        title={'User Management'}
        onBack={onBack}
        section={
          <>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
              }}>
              {/* Search Field */}
              {/* <TextField
                placeholder="Search by name"
                size="small"
                value={searchTerm}
                onChange={(e) =>
                  setSearchTerm(e.target.value)
                }
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              /> */}

              <Button
                variant="outlined"
                size="small"
                onClick={handleMainMenuOpen}
                sx={{
                  textTransform: 'none',
                  color: '#333',
                  borderColor: '#ddd',
                  backgroundColor: '#fff',
                  '&:hover': {
                    borderColor: '#ccc',
                    backgroundColor: '#fafafa',
                  },
                  fontSize: 17,
                }}>
                {buttonLabel}
              </Button>

              {/* Main Menu */}
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMainMenuClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}>
                {Object.entries(MENU_CONFIG).map(
                  ([parentValue, parentObj]) => (
                    <MenuItem
                      key={parentValue}
                      onMouseEnter={(e) =>
                        handleSubMenuOpen(e, parentValue)
                      }>
                      <ListItemText>
                        {parentObj.label}
                      </ListItemText>
                      <ListItemIcon sx={{ minWidth: 30 }}>
                        <ArrowRightIcon fontSize="small" />
                      </ListItemIcon>
                    </MenuItem>
                  )
                )}
              </Menu>

              {/* Submenu */}
              <Menu
                anchorEl={subMenuAnchorEl}
                open={Boolean(subMenuAnchorEl)}
                onClose={() => setSubMenuAnchorEl(null)}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}>
                {MENU_CONFIG[
                  selectedFunction
                ]?.children.map(({ label, value }) => (
                  <MenuItem
                    key={value}
                    selected={selectedSubFunction === value}
                    onClick={() =>
                      handleSelectChild(
                        selectedFunction,
                        value
                      )
                    }>
                    {label}
                  </MenuItem>
                ))}
              </Menu>

              {/* Field Agent Dropdown */}
              <TextField
                select
                size="small"
                value={role}
                onChange={(e) => setRole(e.target.value)}
                sx={{ minWidth: 160 }}>
                {visibleRoles.map((role) => (
                  <MenuItem key={role} value={role}>
                    {ROLE_LABELS[role]}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                select
                size="small"
                value={status}
                onChange={(e) =>
                  setStatus(
                    e.target.value as 'Active' | 'Inactive'
                  )
                }
                sx={{ minWidth: 120 }}>
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Inactive">
                  Inactive
                </MenuItem>
              </TextField>
            </Box>

            {/* Right Section */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
              }}>
              <Button
                startIcon={<HistoryIcon />}
                onClick={() =>
                  // onNavigate?.('importHistory')
                  onNavigate?.('importHistory', {
                    type: 'user',
                  })
                }
                sx={{
                  textTransform: 'none',
                  color: 'rgba(0,105,112,1)',
                  fontWeight: 500,
                }}>
                View History
              </Button>

              <Button
                startIcon={<AddIcon />}
                variant="outlined"
                onClick={handleOpenDrawer}
                sx={{
                  textTransform: 'none',
                  borderColor: 'rgba(0,105,112,1)',
                  color: 'rgba(0,105,112,1)',
                  fontWeight: 500,
                  '&:hover': {
                    borderColor: 'rgba(0,105,112,0.8)',
                    backgroundColor: 'rgba(0,105,112,0.05)',
                  },
                }}>
                Add User
              </Button>

              <Button
                startIcon={<DownloadIcon />}
                variant="contained"
                onClick={() => setOpenImportDrawer(true)}
                sx={{
                  textTransform: 'none',
                  backgroundColor: 'rgba(0,105,112,1)',
                  fontWeight: 500,
                  '&:hover': {
                    backgroundColor: 'rgba(0,105,112,0.9)',
                  },
                }}>
                Import Users
              </Button>
            </Box>
          </>
        }
      />

      <Drawer
        anchor="right"
        open={openDrawer}
        onClose={handleCloseDrawer}
        PaperProps={{
          sx: {
            //  mt: 40,
            width: '50vw',
            // p: 4,
            backgroundColor: '#fff',
          },
        }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 3,
            py: 2,
            borderBottom: '1px solid #E0E0E0',
            boxShadow: '0px 2px 6px rgba(0,0,0,0.04)',
          }}>
          <Typography
            fontSize={17}
            fontWeight={600}
            sx={{ lineHeight: 1 }}>
            Add user
          </Typography>

          <Box
            onClick={handleCloseDrawer}
            sx={{
              width: 24,
              height: 24,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
            }}>
            <img
              src={arrow}
              alt="close"
              style={{ width: 20, height: 20 }}
            />
          </Box>
        </Box>

        <form
          onSubmit={handleSubmit((data) => onSubmit(data))}
          className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6 px-6 py-6 pb-24 md:pb-28">
          <InputController
            label="Name"
            register={register('name')}
            error={errors?.name?.message}
            required
          />
          <InputController
            label="UGDN"
            register={register('ugdn')}
            error={errors?.ugdn?.message}
            required
          />
          <InputController
            label="Mobile number"
            register={register('mobileDetails')}
            error={errors?.mobileDetails?.message}
            required
            digitsOnly
            maxDigits={10}
          />
          {isThailand && (
            <InputController
              label="Email"
              register={register('emailId')}
              error={errors?.emailId?.message}
              required
            />
          )}
          {/* <AutoCompleteController
            control={control}
            name="country"
            label="Country"
            placeholder="Select country"
            options={[
              { value: 'IN', label: 'India' },
              { value: 'TH', label: 'Thailand' },
            ]}
            required
            error={errors?.country?.message}
            disableClearable
          /> */}
          <AutoCompleteController
            control={control}
            name="userType"
            label="Role"
            placeholder="Select Role"
            options={[
              {
                value: 'SCM_LEAD',
                label: 'SCM LEAD',
              },
              {
                value: 'PRODUCTION_LEAD',
                label: 'PRODUCTION LEAD ',
              },
              {
                value: 'REGION_MANAGER',
                label: 'REGION_MANAGER',
              },
              {
                value: 'TPM',
                label: isThailand ? 'APM' : 'TPM',
              },
              {
                value: 'FA',
                label: isThailand ? 'PE' : 'FA',
              },
            ]}
            required
            error={errors?.userType?.message}
            disableClearable
          />
          <AutoCompleteController
            control={control}
            name="userFunction"
            label="Function"
            placeholder="Select function"
            options={[
              {
                value: 'EMP_FIELD_CROP',
                label: 'Field crop',
              },
              {
                value: 'EMP_VEGETABLE_CROP',
                label: 'Vegetable crop',
              },
            ]}
            required
            error={errors?.userFunction?.message}
            disableClearable
          />

          <AutoCompleteController
            control={control}
            name="userSubFunction"
            label="Sub function"
            placeholder="Select Sub function"
            options={[
              {
                value: 'SF_COMMERCIAL_SEED_PRODUCTION',
                label: 'COMMERCIAL SEED PRODUCTION',
              },
              // {
              //   value: 'SF_FC_CROP_QUALITY',
              //   label: 'CROP QUALITY',
              // },
              // {
              //   value: 'SF_PARENT_SEED_PRODUCTION',
              //   label: 'PARENT SEED PRODUCTION',
              // },
              {
                value: 'SF_QUALITY_MANAGEMENT',
                label: 'QUALITY MANAGEMENT',
              },
            ]}
            required
            error={errors?.userSubFunction?.message}
            disableClearable
          />
          {watch('userType') == 'FA' && (
            <MultiSelect
              control={control}
              name="fields"
              label="Fields"
              options={[
                { value: 'def', label: 'def' },
                { value: 'def2', label: 'def2' },
              ]}
              disabled
            />
          )}
          {[
            'FA',
            'TPM',
            'REGION_MANAGER',
            'PRODUCTION_LEAD',
          ].includes(watch('userType')) && (
            <AutoCompleteController
              control={control}
              name={
                watch('userType') == 'FA'
                  ? 'tpm'
                  : watch('userType') == 'TPM'
                  ? 'regionManager'
                  : watch('userType') == 'REGION_MANAGER'
                  ? 'productionLead'
                  : watch('userType') == 'PRODUCTION_LEAD'
                  ? 'scmLead'
                  : 'scmLead'
              } //based on heirarchy
              label={
                watch('userType') == 'FA'
                  ? isThailand
                    ? 'APM'
                    : 'TPM'
                  : watch('userType') == 'TPM'
                  ? 'REGION MANAGER'
                  : watch('userType') == 'REGION_MANAGER'
                  ? 'PRODUCTION LEAD'
                  : watch('userType') == 'PRODUCTION_LEAD'
                  ? 'SCM LEAD'
                  : 'Super Admin'
              }
              placeholder="Select"
              options={
                watch('userType') == 'FA'
                  ? tpmListffc
                  : watch('userType') == 'TPM'
                  ? rmListffc
                  : watch('userType') == 'REGION_MANAGER'
                  ? plListffc
                  : watch('userType') == 'PRODUCTION_LEAD'
                  ? scmListffc
                  : [{ label: 'Kabir', value: 'Kabir' }]
              }
              disableClearable
              required
              error={
                watch('userType') == 'FA'
                  ? errors?.tpm?.message
                  : watch('userType') == 'TPM'
                  ? errors?.regionManager?.message
                  : watch('userType') == 'REGION_MANAGER'
                  ? errors?.productionLead?.message
                  : errors?.scmLead?.message
              }
            />
          )}

          <div className="col-span-full form-control mt-8 flex justify-end gap-4">
            <Button
              variant="outlined"
              onClick={handleCloseDrawer}
              className="mr-2"
              sx={{
                color: '#006970',
                borderColor: '#006970',
              }}>
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{ backgroundColor: 'rgba(0,105,112,1)' }}
              type="submit">
              Save
            </Button>
          </div>
        </form>
      </Drawer>
      <ImportUsersDrawer
        open={openImportDrawer}
        onClose={() => setOpenImportDrawer(false)}
        type={'user'}
        refetch={refetch}
      />
      <EditDrawer
        open={openEditDrawer}
        onClose={() => setOpenEditDrawer(false)}
        type={'user'}
        schema={userSchema}
        data={transformedResponse?.users}
        rowIndex={selectedRowIndex}
        auditData={auditData}
        refetch={refetch}
        initialTab={drawerTab}
        commonFilters={commonFilters}
        isActive={
          selectedRowIndex !== null
            ? transformedResponse?.users?.[selectedRowIndex]
                ?.status === true
            : true
        }
      />
      <div style={{ marginTop: 150 }}></div>
      {seletedIds?.length > 0 && (
        <div className="bulk-action-container">
          <div className="left-section">
            <span className="selected-text">
              {seletedIds.length} Users Selected
            </span>

            {status == 'Active' && (
              <button
                className="deactivate-btn"
                onClick={() =>
                  actionFunction('deactivate')
                }>
                Deactivate User
              </button>
            )}
            {status == 'Inactive' && (
              <button
                className="activate-btn"
                onClick={() => actionFunction('activate')}>
                Activate User
              </button>
            )}
          </div>
        </div>
      )}

      {isLoading || isFetching ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="60vh">
          <CircularProgress />
        </Box>
      ) : (
        <MVPDataTableInternal
          type={'user'}
          columns={columnsss}
          data={transformedResponse?.users}
          selectedFieldNo={selectedFieldNo}
          pageSize={pageSize}
          setPageSize={setPageSize}
          totalCount={totalCount}
          pageNo={pageNo}
          setPageNo={setPageNo}
          isLoading={false}
          rowsPerPageOptions={[pageSize]}
          handlePageChange={handlePageChange}
          seletedIds={seletedIds}
          rowKey={'userId'}
        />
      )}
    </div>
  );
};
